import { VpLoader } from '@vtmn-play/react'

export function ProductsListLoader() {
  return (
    <div className="products-list__loader">
      <VpLoader data-testid="products-list-loader" />
    </div>
  )
}
